import type { ThemeTypes } from '@/types/themeTypes/ThemeType';

const DARK_BLUE_THEME: ThemeTypes = {
    name: 'DARK_BLUE_THEME',
    dark: true,
    variables: {
        'border-color': '#333F55',
        'border-opacity': 1
    },
    colors: {
        primary: '#635BFF',
        secondary: '#16CDC7',
        info: '#46caeb',
        success: '#36c76c',
        warning: '#ffd648',
        error: '#ff6692',
        lightprimary: '#1e293b',
        lightsecondary: '#0f172a',
        lightsuccess: '#1a2236',
        lighterror: '#202324',
        lightinfo: '#1A365D',
        lightwarning: '#1a2236',
        textPrimary: '#EAEFF4',
        textSecondary: '#7C8FAC',
        borderColor: '#333F55',
        containerBg: '#1a2236',
        background: '#111936',
        hoverColor: '#333f55',
        surface: '#111936',
        grey100: '#333F55',
        grey200: '#46505A',
        darkgray: '#0a2540',
        light: '#1a2236',
        muted: '#7c8fac'
    }
};

const DARK_AQUA_THEME: ThemeTypes = {
    name: 'DARK_AQUA_THEME',
    dark: true,
    variables: {
        'border-color': '#333F55',
        'border-opacity': 1
    },
    colors: {
        primary: '#0074BA',
        secondary: '#47CC5E',
        info: '#46caeb',
        success: '#36c76c',
        warning: '#ffd648',
        error: '#ff6692',
        lightprimary: '#1e293b',
        lightsecondary: '#0f172a',
        lightsuccess: '#1a2236',
        lighterror: '#202324',
        lightinfo: '#1A365D',
        lightwarning: '#1a2236',
        textPrimary: '#EAEFF4',
        textSecondary: '#7C8FAC',
        borderColor: '#333F55',
        containerBg: '#1a2236',
        background: '#111936',
        hoverColor: '#333f55',
        surface: '#111936',
        grey100: '#333F55',
        grey200: '#46505A',
        darkgray: '#0a2540',
        light: '#1a2236',
        muted: '#7c8fac'
    }
};

const DARK_ORANGE_THEME: ThemeTypes = {
    name: 'DARK_ORANGE_THEME',
    dark: true,
    variables: {
        'border-color': '#333F55',
        'border-opacity': 1
    },
    colors: {
        primary: '#FB8C00',
        secondary: '#E91E63',
        info: '#46caeb',
        success: '#36c76c',
        warning: '#ffd648',
        error: '#ff6692',
        lightprimary: '#1e293b',
        lightsecondary: '#0f172a',
        lightsuccess: '#1a2236',
        lighterror: '#202324',
        lightinfo: '#1A365D',
        lightwarning: '#1a2236',
        textPrimary: '#EAEFF4',
        textSecondary: '#7C8FAC',
        borderColor: '#333F55',
        containerBg: '#1a2236',
        background: '#111936',
        hoverColor: '#333f55',
        surface: '#111936',
        grey100: '#333F55',
        grey200: '#46505A',
        darkgray: '#0a2540',
        light: '#1a2236',
        muted: '#7c8fac'
    }
};

const DARK_PURPLE_THEME: ThemeTypes = {
    name: 'DARK_PURPLE_THEME',
    dark: true,
    variables: {
        'border-color': '#333F55',
        'border-opacity': 1
    },
    colors: {
        primary: '#7352FF',
        secondary: '#2994FF',
        info: '#46caeb',
        success: '#36c76c',
        warning: '#ffd648',
        error: '#ff6692',
        lightprimary: '#1e293b',
        lightsecondary: '#0f172a',
        lightsuccess: '#1a2236',
        lighterror: '#202324',
        lightinfo: '#1A365D',
        lightwarning: '#1a2236',
        textPrimary: '#EAEFF4',
        textSecondary: '#7C8FAC',
        borderColor: '#333F55',
        containerBg: '#1a2236',
        background: '#111936',
        hoverColor: '#333f55',
        surface: '#111936',
        grey100: '#333F55',
        grey200: '#46505A',
        darkgray: '#0a2540',
        light: '#1a2236',
        muted: '#7c8fac'
    }
};

const DARK_GREEN_THEME: ThemeTypes = {
    name: 'DARK_GREEN_THEME',
    dark: true,
    variables: {
        'border-color': '#333F55',
        'border-opacity': 1
    },
    colors: {
        primary: '#0A7EA4',
        secondary: '#CCDA4E',
        info: '#46caeb',
        success: '#36c76c',
        warning: '#ffd648',
        error: '#ff6692',
        lightprimary: '#1e293b',
        lightsecondary: '#0f172a',
        lightsuccess: '#1a2236',
        lighterror: '#202324',
        lightinfo: '#1A365D',
        lightwarning: '#1a2236',
        textPrimary: '#EAEFF4',
        textSecondary: '#7C8FAC',
        borderColor: '#333F55',
        containerBg: '#1a2236',
        background: '#111936',
        hoverColor: '#333f55',
        surface: '#111936',
        grey100: '#333F55',
        grey200: '#46505A',
        darkgray: '#0a2540',
        light: '#1a2236',
        muted: '#7c8fac'
    }
};

const DARK_CYAN_THEME: ThemeTypes = {
    name: 'DARK_CYAN_THEME',
    dark: true,
    variables: {
        'border-color': '#333F55',
        'border-opacity': 1
    },
    colors: {
        primary: '#01C0C8',
        secondary: '#FB9678',
        info: '#46caeb',
        success: '#36c76c',
        warning: '#ffd648',
        error: '#ff6692',
        lightprimary: '#1e293b',
        lightsecondary: '#0f172a',
        lightsuccess: '#1a2236',
        lighterror: '#202324',
        lightinfo: '#1A365D',
        lightwarning: '#1a2236',
        textPrimary: '#EAEFF4',
        textSecondary: '#7C8FAC',
        borderColor: '#333F55',
        containerBg: '#1a2236',
        background: '#111936',
        hoverColor: '#333f55',
        surface: '#111936',
        grey100: '#333F55',
        grey200: '#46505A',
        darkgray: '#0a2540',
        light: '#1a2236',
        muted: '#7c8fac'
    }
};

export {
    DARK_BLUE_THEME,
    DARK_AQUA_THEME,
    DARK_ORANGE_THEME,
    DARK_PURPLE_THEME,
    DARK_GREEN_THEME,
    DARK_CYAN_THEME
};
